import { render, staticRenderFns } from "./AdminNotice.vue?vue&type=template&id=7852f664&scoped=true"
import script from "./AdminNotice.vue?vue&type=script&lang=js"
export * from "./AdminNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7852f664",
  null
  
)

export default component.exports